import { render } from "./CieloFarol.vue?vue&type=template&id=0fd100eb"
import script from "./CieloFarol.vue?vue&type=script&lang=js"
export * from "./CieloFarol.vue?vue&type=script&lang=js"

import "./CieloFarol.vue?vue&type=style&index=0&id=0fd100eb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__